import { useMemo } from 'react';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useEventWithDimensions from 'hooks/useEventWithDimensions';

import {
    arrayBufferToString,
    generateTabs,
} from 'components/Dashboards/Project/Components/VersionCompare/utils/helper';
import { UseLargestDeletedActivitiesProvider } from 'components/widgets/LargestDeletedActivities/LargestDeletedActivities.provider';

interface Props {
    ui: UseLargestDeletedActivitiesProvider['ui'];
    api: UseLargestDeletedActivitiesProvider['api'];
    title: string;
    subTitle: string;
}

export const useLargestDeletedActivitiesLogic = ({ ui, api, title, subTitle }: Props) => {
    const { handleSnackBar } = useCustomSnackBar();
    const { sendEventWithDimensions } = useEventWithDimensions();

    const tableData = useMemo(() => {
        if (api.getLargestDeletedActivitiesTableData?.instance.data?.periodItemsList) {
            const periodItemsList = api.getLargestDeletedActivitiesTableData.instance.data.periodItemsList;
            return (
                periodItemsList.find((item) => item.id === ui.state.activeTab)?.itemsList ||
                periodItemsList[0].itemsList
            );
        }
        return [];
    }, [api.getLargestDeletedActivitiesTableData.instance.data, ui.state.activeTab]);

    const handleAPIExcelExport = () => {
        api.exportCsvReport.instance.mutate(api.exportCsvReport.payload, {
            onSuccess: () => {
                handleSnackBar('File Successfully Downloaded', 'success');

                sendEventWithDimensions({
                    category: 'Export',
                    action: 'Excel',
                    label: `${title} ${subTitle}`,
                });
            },
            onError: (error) => {
                const message = arrayBufferToString(error?.response?.data);
                DEFAULT_ERROR({ error, message, handleError: handleSnackBar });
            },
        });
    };

    const tabsData = generateTabs({ data: api.getLargestDeletedActivitiesTableData.instance.data });
    return {
        logic: {
            handleAPIExcelExport,
            tableData,
            tabsData,
        },
    };
};
